var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"modern-shell",class:{ 'modern-shell--document': _vm.contentLayout === 'document' }},[_c('main',{staticClass:"modern-shell__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }